<template>
    <div class="section col_w_3">
        <div class="section_wrap terms_of_use">
            <div class="section_title">{{ $t('account.the_terms_use') }}</div>
            <vue-friendly-iframe :src="agreementUrl1" :crossorigin="''" class=""/>
        </div>
    </div>
</template>
<script>
    import {_API} from '@/static';
    export default {
        name: 'TermsOfUse',
        components: {},
        data() {
            return {
                agreementUrl1 : ''
            }
        },
        methods: {
        },
        created() {
            this.agreementUrl1 = `${_API}/companyInfo/agreement/termsOfUsage/clinic?tz=${this._TIME_ZONE}`;
        }
    }
</script>
<style lang="scss">
    .terms_of_use {
        .vue-friendly-iframe {
            & iframe {
                width: 100%;
                height: 500px;
            }
        }
    }
</style>